import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { StyledHeader } from "../../styled-components/StyledHeader.style";
import { HeaderMenuAction } from "../../components/HeaderMenuAction";
import { HeaderMenuAccount } from "../../components/HeaderMenuAccount";
import { HamburgerMenu } from "../HamburgerMenu";
import logo from "../../assets/logo-siscope.png";
import { MobileContext } from "../../contexts/MobileContext";

export const Header = ({ isMenuOpen, setIsMenuOpen }) => {
    const isMobile = useContext(MobileContext);
    const [isMenuDesktopOpen, setIsMenuDesktopOpen] = useState(false);
    const currentEnv = window.APP_CONFIG?.ENV;
    return (
        <StyledHeader>
            {isMobile && (
                <div>
                    <HamburgerMenu onClick={() => setIsMenuOpen(!isMenuOpen)} />
                </div>
            )}
            <div>
                <Link to={"/"}>
                    <img src={logo} alt="Siscope" title="Siscope" />
                </Link>
            </div>
            {/* {!isMobile && (process.env.REACT_APP_ENV === "treinamento" || process.env.REACT_APP_ENV === "homologacao" || process.env.REACT_APP_ENV === "local") && (
                <div className="badge bg-lightblue border-0 py-2 ms-5" style={{fontSize: "12px"}}>
                    {process.env.REACT_APP_ENV.toUpperCase()}
                </div>
            )} */}
            {!isMobile && ["treinamento", "homologacao", "local"].includes(currentEnv) && (
                <div className="badge bg-lightblue border-0 py-2 ms-5" style={{fontSize: "12px"}}>
                    {currentEnv.toUpperCase()}
                </div>
            )}
            <div className="d-flex align-items-center">                
                {!isMobile && (
                    <>
                        <h2 className="info text-darkgrey text-uppercase my-0 mr-3">
                            Acesso rápido
                        </h2>
                        <HeaderMenuAction />
                    </>
                )}
                <HeaderMenuAccount isMenuDesktopOpen={isMenuDesktopOpen} setIsMenuDesktopOpen={setIsMenuDesktopOpen}></HeaderMenuAccount>
            </div>
        </StyledHeader>
    );
};
